<template>
  <div>
    <a-row>
      <a-col :span="24">
        <div class="top">
          <span class="a-span">角色名称：</span>
          <a-input
            class="a-input"
            v-model="roleName"
            placeholder="请输入角色名称"
          ></a-input>
          <span class="b-span">角色描述：</span>
          <a-textarea
            v-model="roleDesc"
            class="a-textarea"
            placeholder="请输入角色描述"
            :rows="4"
          />
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <div class="top" style="height: auto;">
          <a-tree
            class="tree"
            checkable
            :check-strictly="true"
            :checked-keys="checkedKeys"
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :selected-keys="selectedKeys"
            :tree-data="ywArr"
            @expand="onExpand"
            @check="onCheck"
            @select="onSelect"
            :replaceFields="{ children: 'children' }"
          />
        </div>
      </a-col>
    </a-row>
    <div class="s-button">
      <a-button @click="save">保存</a-button>
      <a-button @click="goBack">返回</a-button>
    </div>
  </div>
</template>
<script>
import {
  storePermissionsListAdd,
  storePermissionsListCreate,
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const ywArr = [];
const xmArr = [];
const treeData = [
  {
    title: "0-0-0-1",
    key: "0-0",
    children: [
      {
        title: "0-0-0",
        key: "0-0-0",
      },
      {
        title: "0-0-1",
        key: "0-0-1",
        children: [
          { title: "0-0-1-0", key: "0-0-1-0" },
          { title: "0-0-1-1", key: "0-0-1-1" },
          { title: "0-0-1-2", key: "0-0-1-2" },
        ],
      },
      {
        title: "0-0-2",
        key: "0-0-2",
      },
    ],
  },
  {
    title: "0-1",
    key: "0-1",
    children: [
      { title: "0-1-0-0", key: "0-1-0-0" },
      { title: "0-1-0-1", key: "0-1-0-1" },
      { title: "0-1-0-2", key: "0-1-0-2" },
    ],
  },
  {
    title: "0-2",
    key: "",
  },
  {
    title: "0-3",
    key: "",
  },
  {
    title: "0-4",
    key: "",
  },
  {
    title: "0-5",
    key: "",
  },
  {
    title: "0-6",
    key: "",
  },
  {
    title: "0-7",
    key: "",
  },
  {
    title: "0-8",
    key: "",
  },
  {
    title: "0-9",
    key: "",
  },
  {
    title: "0-10",
    key: "",
  },
];
export default {
  data() {
    return {
      treeData,
      expandedKeys: ["0-0-0", "0-0-1"],
      autoExpandParent: true,
      checkedKeys: [], // 初始化为空数组，等待树形数据加载后再设置
      selectedKeys: [],
      xmArr,
      ywArr,
      menuIdList: [],
      roleName: "",
      roleDesc: "",
    };
  },
  watch: {
    checkedKeys(val) {
      console.log("onCheck", val);
    },
  },
  mounted() {
    this.getStorePermissionsListAdd();
  },
  inject: ["reload"],
  methods: {
    onExpand(expandedKeys) {
      console.log("onExpand", expandedKeys);
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys, e) {
      console.log("onCheck", checkedKeys, e);
      // checkedKeys 可能是对象或数组，需要兼容处理
      const keys = Array.isArray(checkedKeys) ? checkedKeys : (checkedKeys.checked || []);
      
      // 构建父子关系映射并自动添加父节点
      const allKeysWithParents = this.addParentNodes(keys, this.ywArr);
      
      this.checkedKeys = allKeysWithParents;
      this.menuIdList = allKeysWithParents;
    },
    // 为选中的节点自动添加其父节点
    addParentNodes(selectedKeys, treeData) {
      console.log("addParentNodes 输入 selectedKeys:", selectedKeys);
      
      // 创建树形结构的映射，用于查找父子关系
      const treeMap = new Map();
      
      // 遍历 ywArr 构建树形映射
      treeData.forEach(parent => {
        treeMap.set(parent.key, parent);
        if (parent.children && parent.children.length > 0) {
          parent.children.forEach(child => {
            treeMap.set(child.key, { ...child, parentId: parent.key });
          });
        }
      });
      
      console.log("treeMap 大小:", treeMap.size);
      console.log("treeData 长度:", treeData.length);
      
      const resultKeys = new Set(selectedKeys);
      
      // 遍历所有选中的 key
      selectedKeys.forEach(key => {
        const node = treeMap.get(key);
        // 如果节点有 parentId，说明是子节点，需要添加父节点的 id
        if (node && node.parentId) {
          console.log("选中子节点:", key, "，自动添加父节点:", node.parentId);
          resultKeys.add(node.parentId);
        }
      });
      
      const result = Array.from(resultKeys);
      console.log("addParentNodes 输出:", result);
      return result;
    },
    onSelect(selectedKeys, info) {
      console.log("onSelect", info);
      this.selectedKeys = selectedKeys;
    },
    getStorePermissionsListAdd() {
      storePermissionsListAdd().then((res) => {
        res.data.map((item) => {
          this.ywArr.push({
            title: item.name,
            key: item.objId,
            children: this.loop(item.children),
          });
        });
      });
    },
    loop(item) {
      if (item !== null) {
        console.log(item, "item ==> 不为null");
        let arr = [];
        item.forEach((item) => {
          arr.push({
            title: item.name,
            key: item.objId,
          });
        });
        return arr;
      }
    },
    save() {
      let obj = {
        isShop: 1,
        roleName: this.roleName,
        roleDesc: this.roleDesc,
        menuIdList: this.checkedKeys,
      };
      if (this.roleName.trim() !== "") {
        storePermissionsListCreate(obj).then((res) => {
          message.success(res.info);
          this.$router.push("/home/partManagementTwo/partManagementHomeTwo");
          location.reload();
        });
      } else {
        message.warning("角色名称不可为空");
      }
    },
    goBack() {
      this.$router.push("/home/partManagementTwo/partManagementHomeTwo");
      location.reload();
    },
  },
};
</script>

<style scoped>
.s-button {
  margin-left: 20px;
}
.tree {
  position: relative;
  left: 160px;
}
.a-span {
  position: relative;
  left: 80px;
  top: 25px;
}
.b-span {
  position: relative;
  top: 75px;
  left: 80px;
}
.a-input {
  position: relative;
  left: 160px;
  display: block;
  width: 350px;
}
.a-textarea {
  position: relative;
  left: 160px;
  top: 50px;
  display: block;
  width: 450px;
}
.top {
  margin: 15px;
  height: 400px;
  background-color: rgb(255, 255, 255);
}
</style>


// WEBPACK FOOTER //
// src/views/right/partManagementTwo/addpartManagementTwo/addpartManagementTwo.vue